// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#55c81e","primaryColorLight":"#61d728","primaryColorLighter":"#93da72","primaryColorLightest":"#c3e8b1"};